import { yupResolver } from '@hookform/resolvers/yup'
import { ControlledDateOnlyPicker, ControlledTextField, stopPropagationSubmitHandler } from '@if/mui'
import { Stack } from '@mui/material'
import FormDialog from '@src/components/Common/Dialog/FormDialog'
import { FC } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InterestConfigurationSchema, type InterestConfigurationSchemaType } from './loan-form-schema'

interface InterestRateConfigurationDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (data: InterestConfigurationSchemaType) => void
  defaultValues?: InterestConfigurationSchemaType
}

const InterestRateConfigurationDialog: FC<InterestRateConfigurationDialogProps> = ({
  open,
  onClose,
  onSubmit,
  defaultValues,
}) => {
  const { t } = useTranslation()
  const { handleSubmit, reset, control } = useForm<InterestConfigurationSchemaType>({
    resolver: yupResolver(InterestConfigurationSchema),
    defaultValues,
    shouldFocusError: !!defaultValues,
  })

  const handleClose = () => {
    reset()
    onClose()
  }

  const onSubmitHandler = (data: InterestConfigurationSchemaType) => {
    reset()
    onClose()
    onSubmit(data)
  }

  return (
    <FormDialog
      title={t('loan.interestRateConfiguration.add')}
      onClose={handleClose}
      onConfirm={stopPropagationSubmitHandler(handleSubmit(onSubmitHandler))}
      open={open}
    >
      <Stack rowGap={2} columnGap={1}>
        <ControlledDateOnlyPicker
          control={control}
          name="startDate"
          label={t('loan.interestRateConfiguration.startsOn')}
        />
        <ControlledDateOnlyPicker control={control} name="endDate" label={t('loan.interestRateConfiguration.endsOn')} />
        <ControlledTextField
          control={control}
          name="rate"
          type="number"
          label={t('loan.interestRateConfiguration.interestRate')}
          autoFocus={!!defaultValues?.rate}
        />
      </Stack>
    </FormDialog>
  )
}

export default InterestRateConfigurationDialog
